document.addEventListener('DOMContentLoaded',()=>{
  document.querySelectorAll('[data-mobile-toggle]').forEach(btn=>btn.addEventListener('click',()=>{const el=document.querySelector('[data-mobile-menu]'); if(el) el.hidden=!el.hidden;}));

  const form=document.querySelector('#SellCardsForm');
  if(!form) return;
  const steps=[...form.querySelectorAll('[data-sell-step]')];
  const dots=[...form.querySelectorAll('[data-progress]')];
  let current=0;

  const render=()=>{
    steps.forEach((step,i)=>{const active=i===current; step.hidden=!active; step.classList.toggle('is-active',active);});
    dots.forEach((dot,i)=>{dot.classList.toggle('is-active',i===current);dot.classList.toggle('is-done',i<current);const line=dot.nextElementSibling;if(line&&line.tagName==='I') line.classList.toggle('is-done',i<current);});
    const target=steps[current]; if(target) target.scrollIntoView({behavior:'smooth',block:'center'});
  };
  const validateStep=()=>{
    const fields=[...steps[current].querySelectorAll('input,select,textarea')].filter(el=>el.required);
    for(const field of fields){if(!field.checkValidity()){field.reportValidity();field.focus();return false;}}
    return true;
  };
  form.querySelectorAll('[data-sell-next]').forEach(btn=>btn.addEventListener('click',()=>{if(validateStep()&&current<steps.length-1){current++;render();}}));
  form.querySelectorAll('[data-sell-prev]').forEach(btn=>btn.addEventListener('click',()=>{if(current>0){current--;render();}}));
  const success=form.querySelector('[data-sell-success]'); if(success) success.focus();
});
